import Vue from 'vue'

const watermark = {
  install(Vue) {
    Vue.directive('watermark', {
      bind(el, binding) {
        const text = binding.value || 'watermark';
        const canvas = document.createElement('canvas');
        canvas.width = 200;
        canvas.height = 150;
        const ctx = canvas.getContext('2d');

        ctx.font = '20px Arial';
        ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
        ctx.rotate((-20 * Math.PI) / 180);
        ctx.fillText(text, 10, 100);

        el.style.position = 'absolute';
        const watermark = document.createElement('div');
        watermark.style.width = '99vw';
        watermark.style.height = '99vh';
        watermark.style.position = 'absolute';
        watermark.style.zIndex = '10';
        watermark.style.top = '0';
        watermark.style.left = '0';
        watermark.style.right = '0';
        watermark.style.bottom = '0';
        watermark.style.backgroundImage = `url(${canvas.toDataURL('image/png')})`;
        watermark.style.backgroundRepeat = 'repeat'; // 根据需求设置背景重复方式
        watermark.style.pointerEvents = 'none'; // 防止水印层影响点击
        el.appendChild(watermark);
      }
    })
  }
}

const tool = {
  watermark
}
export default tool;



// WEBPACK FOOTER //
// ./src/utils/watermark.js